import React from 'react';

import { DateTime } from 'luxon';

import { Currency } from '@shared/components/helpers';

import { RateAdjustment__Scheduling } from '@admin/schema';

export type SummaryScheduling = Pick<RateAdjustment__Scheduling, 'effectiveAt' | 'newPrice' | 'percentageWithSign'>;

export const Summary: React.FC<{ scheduling: SummaryScheduling }> = ({
  scheduling: { effectiveAt, newPrice, percentageWithSign },
}) => (
  <>
    {DateTime.fromISO(effectiveAt).toUTC().toLocaleString(DateTime.DATE_FULL)} to <Currency value={newPrice} /> (
    {percentageWithSign})
  </>
);
